import React from 'react';
import PropTypes from 'prop-types';

const CheckMark = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1000 728.01"
      role="img"
    >
      <title>Checkmark</title>
      <path
        fill={color}
        d="M369.19,670.36,97.2,398.55l-97,97L369,864.15l631.2-631.21-98.61-96.8Z"
        transform="translate(-0.21 -136.14)"
      />
    </svg>
  );
};

export default CheckMark;

CheckMark.propTypes = {
  color: PropTypes.string.isRequired,
};
